<table class="table is-fullwidth is-hoverable" width="100%">
  <thead>
    <tr>
      <!-- Dynamic status column -->
      @if (hasAnyStatus) {
      <th class="status-column"></th>
      } @for (yield of yields; track yield) {
      <th
        class="{{ yield.headingClassName }}"
        [class.has-text-right]="yield.type === YieldType.Currency"
      >
        @if (yield.disableOrderBy) {
        <span>{{ yield.label }}</span>
        } @if (!yield.disableOrderBy) {
        <a class="no-deco" (click)="order(yield)"
          >{{ yield.label }}
          <span
            class="tooltip has-tooltip has-tooltip-bottom"
            [attr.data-tooltip]="yield.tooltip"
          >
            @if (yield.tooltip) {
            <i class="icon icon-info is-size-5 has-text-link"></i>
            }
          </span>
          @if ( orderBy && (orderBy === yield.orderByProperty || orderBy ===
          yield.property) ) {
          <i
            class="icon"
            [class.icon-chevron-up]="orderByDesc"
            [class.icon-chevron-down]="!orderByDesc"
          ></i>
          }
        </a>
        }
      </th>
      } @if (definition.actionButtons && definition.actionButtons.length &&
      !isReadOnlyTaxonomy(definition.slug)) {
      <th class="has-text-right"></th>
      } @if (definition.dropdownLinks.length &&
      !isReadOnlyTaxonomy(definition.slug)) {
      <th class="has-text-right" width="115"></th>
      }
    </tr>
  </thead>
  <tbody>
    @for (item of formattedItems; track trackByItem(item); let i = $index) {
    <tr class="pos-{{ i }} rev-pos-{{ formattedItems.length - 1 - i }}">
      <!-- Dynamic status column -->
      @if (hasAnyStatus) {
      <td class="status-column">
        @if (getStatusLabel(item)) {
        <span class="status-label {{ getStatusClass(item) }}">{{
          getStatusLabel(item)
        }}</span>
        }
      </td>
      } @for (yield of item.yields; track yield) {
      <td
        [width]="yield.width"
        [class]="yield.className"
        [class.pointer]="definition.defaultLink"
        [class.has-custom-link]="yield.link"
        [class.has-text-right]="yield.type === YieldType.Currency"
        (click)="onYieldClick(yield, item, $event)"
      >
        <div class="cell-content">
          @if (yield.routerLink) {
          <a
            [routerLink]="yield.routerLink.pathWithoutParams"
            [queryParams]="yield.routerLink.queryParams"
          >
            <case-yield [yield]="yield"></case-yield>
          </a>
          } @else {
          <case-yield [yield]="yield"></case-yield>
          }
        </div>
      </td>
      } @if (definition.actionButtons && definition.actionButtons.length &&
      !isReadOnlyTaxonomy(definition.slug)) {
      <td class="has-text-right" width="200">
        <!-- Action buttons loop -->
        @for (actionButton of item.actionButtons; track actionButton) {
        <a
          [class]="actionButton.className"
          [caseAction]="actionButton.action(item)"
        >
          @if (actionButton.icon) {
          <i class="icon is-size-5" [class]="actionButton.icon"></i>
          }
          {{ actionButton.label }}
        </a>
        }
      </td>
      } @if (definition.dropdownLinks.length &&
      !isReadOnlyTaxonomy(definition.slug)) {
      <td class="has-text-right">
        @if (definition.dropdownLinks && definition.dropdownLinks.length) {
        <case-action-dropdown
          [item]="item"
          [definition]="definition"
          [preventDeleteMessage]="item.preventDeleteMessage"
        ></case-action-dropdown>
        }
      </td>
      }
    </tr>
    } @if (formattedItems && !formattedItems.length) {
    <tr>
      <td [attr.colspan]="yields.length">No {{ definition.nameSingular }}</td>
    </tr>
    }
  </tbody>
</table>
